<template>
  <v-row no-gutters justify="end">
    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn :icon="mdiPencil" variant="text" v-bind="props" @click="$emit('action', { type: 'load', model })" />
      </template>
      Edit/Run Trading Model
    </v-tooltip>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn :icon="mdiContentCopy" variant="text" v-bind="props" @click="$emit('action', { type: 'copy', model })" />
      </template>
      Copy Trading Model
    </v-tooltip>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn v-show="model.status == 3" :icon="mdiEye" variant="text" v-bind="props" @click="$emit('action', { type: 'view', model })" />
      </template>
      View Last Completed Trading Results
    </v-tooltip>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn v-show="model.status == 2 || model.status == 1" :icon="mdiCancel" variant="text" v-bind="props" @click="$emit('action', { type: 'cancel', model })" />
      </template>
      Request Cancel
    </v-tooltip>

    <!-- Move to folder -->
    <v-menu v-if="folders.length" v-model="moveMenu" :close-on-content-click="true">
      <template #activator="{ props }">
        <v-tooltip location="top">
          <template #activator="{ props: tip }">
            <v-btn :icon="mdiFolderMove" variant="text" v-bind="{ ...props, ...tip }" />
          </template>
          Move to Folder
        </v-tooltip>
      </template>
      <v-list density="compact">
        <v-list-item
          v-if="model.folder_id"
          prepend-icon="mdi-folder-remove-outline"
          title="Remove from folder"
          @click="$emit('action', { type: 'move', model, folderId: null })"
        />
        <v-divider v-if="model.folder_id" />
        <v-list-item
          v-for="folder in folders"
          :key="folder.id"
          :disabled="model.folder_id === folder.id"
          :title="folder.name"
          prepend-icon="mdi-folder-outline"
          @click="$emit('action', { type: 'move', model, folderId: folder.id })"
        />
      </v-list>
    </v-menu>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn :icon="mdiShareOff" variant="text" v-bind="props" @click="$emit('action', { type: 'unshare', model })" />
      </template>
      Unshare Trading Model
    </v-tooltip>

    <v-tooltip location="top">
      <template #activator="{ props }">
        <v-btn :icon="mdiDelete" variant="text" v-bind="props" @click="$emit('action', { type: 'delete', model })" />
      </template>
      Delete Trading Model
    </v-tooltip>
  </v-row>
</template>

<script>
import {
  mdiPencil, mdiContentCopy, mdiEye, mdiCancel, mdiDelete, mdiShareOff, mdiFolderMove
} from '@mdi/js'

export default {
  props: {
    model: { type: Object, required: true },
    folders: { type: Array, default: () => [] }
  },
  emits: ['action'],
  data: () => ({
    moveMenu: false,
    mdiPencil, mdiContentCopy, mdiEye, mdiCancel, mdiDelete, mdiShareOff, mdiFolderMove
  })
}
</script>
